import React from 'react'
import { Link } from 'react-router-dom'

const Breadecrumb = ({title}) => {
    return (
        <>
            <div className="breadcrumb-main-block">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {title}
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

        </>
    )
}

export default Breadecrumb
